import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { FileText, Clock, Award } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './style/ExamInfo.css';

export default function ExamInfo() {
  const [exams, setExams] = useState([]);
  const navigate = useNavigate();
  const classExam = useSelector((state) => state.teacherSub.selectedClass);
  const subjectExam = useSelector((state) => state.teacherSub.selectedSubject);
  const teacherId = useSelector((state) => state.teacherSub.teacherId);

  useEffect(() => {
    const fetchExams = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/exams', {
          params: { teacherId, subject: subjectExam }
        });
        setExams(response.data.data);
        console.log("examinfo", exams);
      } catch (err) {
        console.error('Error fetching exams:', err);
      }
    };

    if (teacherId) {
      fetchExams();
    }
  }, [teacherId, subjectExam]);

  const handleViewDetails = (id) => {
    navigate(`/exam/details/${id}`);
  };

  return (
    <div className="unique15-exam-info bg-gradient-to-br from-blue-100 to-purple-100">
      <div className="unique15-exam-header">
        <div className="unique15-header-actions">
          <input type="text" placeholder="Search exams" className="unique15-search-input" />
          <button className="unique15-search-button">Search</button>
        </div>
      </div>
      <div className="unique15-exam-grid">
        {exams.map((exam) => (
          <div key={exam._id} className="unique15-exam-card">
            <div className="unique15-exam-icon">
              <FileText size={32} />
            </div>
            <h3 className="unique15-exam-title">{exam.title}</h3>
            <div className="unique15-exam-meta">
              <span className="unique15-exam-duration">
                <Clock size={16} />
                {exam.duration}
              </span>
              <span className="unique15-exam-marks">
                <Award size={16} />
                {exam.totalMarks} marks
              </span>
            </div>
            <button onClick={() => handleViewDetails(exam._id)} className="unique15-view-details">
              View Details
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}